export enum NAME_COOKIE {
  CONVERSATIONS = "conversations",
  PROJECT_COMPONENT = "project-component",
  PROJECT = "project",
  BUILD = "builds",
}
